import { Injectable } from '@angular/core';
import {environment} from "../../../environments/environment";
import {HttpClient} from "@angular/common/http";
import {TableLazyLoadEvent} from "primeng/table";
import {Observable} from "rxjs";
import {IControlTiempo} from "../../shared/interfaces/database/configuracion";
import {Page} from "../../shared/interfaces/pageable";
import {Utils} from "../../../../../lib-base/src/lib/shared";

@Injectable({
  providedIn: 'root'
})
export class ControlTiempoService {
  private readonly baseUrl = `${environment.apiUrl}/api/control-tiempo`;

  constructor(private http: HttpClient) { }

  getAllControls(event: TableLazyLoadEvent): Observable<Page<IControlTiempo>> {
    let params = Utils.getLazyLoadParams(event ?? {});
    return this.http.get<Page<IControlTiempo>>(`${this.baseUrl}/get-all`,
      {params});
  }
  
  getList(): Observable<IControlTiempo[]> {
      return this.http.get<IControlTiempo[]>(`${this.baseUrl}/get-list`);
  }

  crear(body:Omit<IControlTiempo, 'id'>) :Observable<IControlTiempo> {
    return this.http.post<Required<IControlTiempo>>(`${this.baseUrl}/crear`, body);
  }

  actualizar(id: number, body: Omit<IControlTiempo, 'id'>): Observable<IControlTiempo> {
    return this.http.put<Required<IControlTiempo>>(`${this.baseUrl}/actualizar/${id}`, body);
  }
  desactivar(id: number) {
    return this.http.put(`${this.baseUrl}/desactivar/${id}`, {});
  }
}
